import axiosInstance from "../../services/axiosInstance";
import { useModalStore } from "../../store/modalStore";
import { useState } from "react";
import { toast } from "sonner";
import CloseIcon from "@mui/icons-material/Close";

import {
  Dialog,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Typography,
  Grid,
} from "@mui/material";

const ChangePasswordModal = () => {
  const isPasswordResetModalOpen = useModalStore(
    (state) => state.isPasswordResetModalOpen
  );
  const roleEmail = useModalStore((state) => state.roleEmail);
  const setPasswordResetModalOpen = useModalStore(
    (state) => state.setPasswordResetModalOpen
  );

  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  const roleModalCloseHandler = () => {
    setPasswordResetModalOpen(false);
    setPassword("");
    setError(null);
  };

  // Handle change password
  const handleChangePassword = async () => {
    const payload = { email: roleEmail, password };

    try {
      await axiosInstance.post(`/api/v1/users/change-password`, payload);
      setPassword("");
      setPasswordResetModalOpen(false);
    } catch (error: any) {
      setError(error?.message);
      toast.error("Error changing user password. Please try again.");
    }
  };
  return (
    <>
      {isPasswordResetModalOpen && (
        <Dialog
          open={isPasswordResetModalOpen}
          onClose={roleModalCloseHandler}
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "0.938rem",
              height: "auto",
              width: "50rem",
            },
            padding: 2,
          }}
        >
          <Grid
            container
            display={"flex"}
            justifyContent={"space-between"}
            p={1}
            sx={{
              backgroundColor: "#343434",
              color: "white",
            }}
          >
            <Typography variant="h6">{"Change Password"}</Typography>
            <Grid
              item
              onClick={roleModalCloseHandler}
              mt={0.2}
              sx={{
                cursor: "pointer",
              }}
            >
              <CloseIcon />
            </Grid>
          </Grid>

          <DialogContent>
            <Typography fontWeight={600} fontSize={24}>
              Change password for{" "}
              <span style={{ color: "blueviolet" }}>{roleEmail}</span>
            </Typography>
            <TextField
              margin="dense"
              label="Password"
              type="password"
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              variant="filled"
            />
          </DialogContent>
          <DialogActions>
            <Button
              fullWidth
              variant="outlined"
              onClick={roleModalCloseHandler}
              color="error"
              sx={{
                borderRadius: 2,
              }}
            >
              Cancel
            </Button>
            <Button
              fullWidth
              variant="contained"
              onClick={handleChangePassword}
              color="primary"
              sx={{
                borderRadius: 2,
              }}
            >
              Change Password
            </Button>
          </DialogActions>
          {error && <Typography color="error">{error}</Typography>}
        </Dialog>
      )}
    </>
  );
};

export default ChangePasswordModal;
